import React from "react";

function ViewIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.267"
      height="21.851"
      viewBox="0 0 26.267 21.851"
    >
      <path
        id="Path_22543"
        data-name="Path 22543"
        d="M1.182,13.926a13.356,13.356,0,0,1,26.267,0,13.356,13.356,0,0,1-26.267,0ZM14.315,20a6.07,6.07,0,1,0-6.07-6.07A6.07,6.07,0,0,0,14.315,20Zm0-2.428a3.642,3.642,0,1,1,3.642-3.642A3.642,3.642,0,0,1,14.315,17.568Z"
        transform="translate(-1.182 -3)"
        fill="var(--dark-gray)"
      />
    </svg>
  );
}

export default ViewIcon;
